import SkapaHyperlink, { type HyperlinkProps } from "@ingka/hyperlink";

export const Hyperlink = (props: HyperlinkProps) => {
  return <SkapaHyperlink prefix="saleslead__" {...props} />;
};
